import { render, staticRenderFns } from "./New-appraisal.vue?vue&type=template&id=01c7399c&"
import script from "./New-appraisal.vue?vue&type=script&lang=js&"
export * from "./New-appraisal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports